module.exports = __webpack_public_path__ + "img/pinned-cancel.41d125ea.svg";